import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import About from '../components/About';
import Services from '../components/Services';
import Gallery from '../components/Gallery';
import HoursSection from '../components/HoursSection';
import Reviews from '../components/Reviews';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <main className="bg-[#0a0a0a] text-[#f5efe4]">
      <Header />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Gallery />
      <HoursSection />
      <Reviews />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
